"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _Close = _interopRequireDefault(require("mdi-material-ui/Close"));
var _Alert = _interopRequireDefault(require("mdi-material-ui/Alert"));
var _utils = require("../../utils");
var _useIsFocused = _interopRequireDefault(require("../../hooks/useIsFocused"));
var _Select = _interopRequireDefault(require("./Select.styles"));
var _TextField = require("../TextField/TextField.styles");
var _excluded = ["error", "helperText", "label", "labelHidden", "children", "disabled", "defaultValue", "name", "id", "className", "onChange", "onFocus", "onBlur", "FormControlProps", "SelectProps", "InputLabelProps", "placeholder", "required"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var generatedId = (0, _utils.idGenerator)('Select');
var Select = function Select(_ref) {
  var _classNames;
  var error = _ref.error,
    helperText = _ref.helperText,
    label = _ref.label,
    labelHidden = _ref.labelHidden,
    children = _ref.children,
    disabled = _ref.disabled,
    defaultValue = _ref.defaultValue,
    name = _ref.name,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? generatedId('custom') : _ref$id,
    className = _ref.className,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    FormControlProps = _ref.FormControlProps,
    SelectProps = _ref.SelectProps,
    InputLabelProps = _ref.InputLabelProps,
    placeholder = _ref.placeholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _Select.default)();
  var classesTextField = (0, _TextField.useTextFieldStyles)();
  var selectRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasValue = _useState2[0],
    setHasValue = _useState2[1];
  var isFocused = (0, _useIsFocused.default)(selectRef.current);
  (0, _react.useEffect)(function () {
    var selectElem = null;
    if (selectRef && selectRef.current) {
      selectElem = selectRef.current.querySelector('select');
    }
    setHasValue(Boolean(selectElem && selectElem.value));
  }, []);
  var hasError = Boolean(error);

  // EVENTS
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e);
    }
    setHasValue(Boolean(e.target.value));
  };
  var handleFocus = function handleFocus(e) {
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleBlur = function handleBlur(e) {
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleClearAll = function handleClearAll(e) {
    var event = (0, _utils.buildEventTarget)(name, '');
    var realSelect = selectRef.current.querySelector('select');
    realSelect.value = '';
    setHasValue(false);
    if (onChange) {
      onChange(event);
    }
  };

  // STYLES
  var cssInputBase = (0, _classnames.default)(classesTextField.inputBase, (_classNames = {}, _defineProperty(_classNames, classesTextField.inputDisabled, disabled), _defineProperty(_classNames, classesTextField.inputError, hasError), _classNames));
  var cssSelect = (0, _classnames.default)(classes.select, _defineProperty({}, classes.emptyValue, !hasValue));
  var cssHelperTextContainer = (0, _classnames.default)(classesTextField.helperTextContainer, _defineProperty({}, classesTextField.helperTextDisabled, disabled));
  var cssClearAll = (0, _classnames.default)(classes.clearAll, _defineProperty({}, classes.clearAllFocused, isFocused));
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, _extends({
    fullWidth: true,
    disabled: disabled
  }, FormControlProps, {
    error: hasError
  }), !labelHidden && /*#__PURE__*/_react.default.createElement(_core.InputLabel, _extends({
    classes: {
      root: classesTextField.inputLabel
    },
    shrink: true,
    htmlFor: id
  }, InputLabelProps), label, required && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.required
  }, " *")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.containerInput
  }, /*#__PURE__*/_react.default.createElement(_core.NativeSelect, _extends({
    ref: selectRef,
    name: name,
    classes: {
      select: cssSelect,
      icon: classes.icon,
      disabled: classesTextField.inputDisabled
    },
    defaultValue: defaultValue,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    input: /*#__PURE__*/_react.default.createElement(_TextField.TextInputBase, {
      disabled: disabled,
      className: cssInputBase,
      id: id,
      error: hasError
    }),
    inputProps: SelectProps
  }, props), placeholder && /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true,
    selected: true,
    hidden: true
  }, placeholder), children), hasValue && !disabled && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: cssClearAll,
    onClick: handleClearAll
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    fontSize: "inherit"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: cssHelperTextContainer
  }, error && /*#__PURE__*/_react.default.createElement("div", {
    className: classesTextField.errorContainer
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    fontSize: "inherit"
  }), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, null, error)), !error && helperText && /*#__PURE__*/_react.default.createElement(_core.FormHelperText, null, helperText)));
};
var _default = Select;
exports.default = _default;